import { defineComponent as _defineComponent } from 'vue'
import { Activity } from 'farmdok-rest-api';
import groupby from 'lodash.groupby';
import sortby from 'lodash.sortby';
import { computed, ref, watch } from 'vue';

import ActivityTypeFilters from '@/activities/components/ActivityTypeFilters.vue';
import TableActivitiesContainer from '@/activities/containers/table/TableActivitiesContainer.vue';
import columns from '@/map/handsontable/columns';
import SearchBar from '@/shared/components/SearchBar.vue';
import SidebarHeadline from '@/shared/components/SidebarHeadline.vue';
import { FilterByColumnKey } from '@/shared/handsontable/rework/features/filter/types';
import { Data } from '@/shared/mixins/store/types';
import isUnique from '@/shared/modules/isUniqueFilter';
import notNullOrUndefined from '@/shared/modules/notNullOrUndefinedFilter';
import { useStore } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarActivities',
  props: {
    headline: null,
    description: null
  },
  setup(__props: any) {

const props = __props as {
  headline?: string;
  description?: string;
}

const store = useStore();
const targetColumn = 'activityTypeDropdownItem';

/* -- PROPS -- */


/* -- REACTIVE -- */

const filterString = ref<string>('');
const tableContainer = ref<InstanceType<typeof TableActivitiesContainer>>(); // reference to table container in template

/* -- COMPUTED -- */

const sortedActivityTypes = computed<string[]>(() => sortAvailableTypes(store.state.activities.data));
const activeFilters = computed<string[]>(
  () => tableContainer.value?.$refs.table?.filtersByColumnKey[targetColumn]?.selectedValues || [],
);

/* -- WATCHER -- */

watch(
  () => store.getters['activities/selectedActivities'],
  (activities: Activity[]) => loadGpsDataForSelectedActivities(activities),
  { deep: true },
);

/* -- METHODS -- */

function sortAvailableTypes(activitiesData: Data<Activity>): string[] {
  const activities = Object.values(activitiesData);
  const availableActivityTypes: Set<string> = new Set(activities.map((activity: Activity) => activity.activityTypeId));
  const activitiesByActivityType = groupby(activities, (activity: Activity) => activity.activityTypeId);
  return sortby([...availableActivityTypes], (activityType: string) => activitiesByActivityType[activityType].length)
    .reverse()
    .map((activityTypeId: string) => store.state.activityTypes.data[activityTypeId]?.displayName)
    .filter(notNullOrUndefined);
}

function onBadgeFilter(badgeFilter: FilterByColumnKey | null): void {
  if (badgeFilter?.selectedValues.length) {
    tableContainer.value?.$refs.table.setFilterByColumnKey('activityTypeDropdownItem', badgeFilter);
  } else {
    tableContainer.value?.$refs.table?.clearAllFilters();
  }
}

async function loadGpsDataForSelectedActivities(activities: Activity[]): Promise<void> {
  const activityIds = activities.map((activity: Activity) => activity.id);
  const trackIds = activities
    .map((activity: Activity) => activity.trackId)
    .filter(isUnique)
    .filter(notNullOrUndefined);

  await Promise.all([
    store.dispatch('activities/gpsTrack/refreshByIds', activityIds),
    store.dispatch('activities/gpsLog/refreshByIds', activityIds),
    store.dispatch('tracks/refreshByIds', trackIds),
  ]);
}

return { __sfc: true,store, targetColumn, props, filterString, tableContainer, sortedActivityTypes, activeFilters, sortAvailableTypes, onBadgeFilter, loadGpsDataForSelectedActivities, ActivityTypeFilters, TableActivitiesContainer, columns, SearchBar, SidebarHeadline }
}

})